import { useFetchWebsiteHeaderSettings } from '@apps/guest/packages/layout-engine/layouts/hooks/useWebsiteHeaderSettings/useWebsiteHeaderSettings';
import { useFetchCustomPageData } from '@apps/guest/packages/layout-engine/widgets/Custom/useFetchCustomPageData';
import { useIsStaysRedesignActive } from '@apps/guest/packages/layout-engine/widgets/Custom/components/Honeymoon/useIsStaysRedesignActive';
import { useIsGuestSiteSsrEnabled } from '@apps/guest/shared/hooks/useIsGuestSiteSsrEnabled';
import { useFetchWebsitePageListData } from '@shared/hooks/useWebsitePages';

type UsePrefetchSsrQueriesArgs = Readonly<{
  eventHandle: string;
}>;

// Layout-level prefetches above the `event && layout` gate so they fire concurrently with
// EventWebsiteGuest. Honeymoon-redesign accommodations prefetch lives in a conditionally-
// mounted renderer (`HoneymoonAccommodationsPrefetchRenderer` in GuestSiteBody.tsx) so its
// GuestEventHotelRoomBlocks observer never registers on non-redesign events — the
// controller's `client.refetchQueries({ include: refetchPageQueries.accommodations })` would
// otherwise pick it up by operation name and bypass the hook's internal skip.
export const usePrefetchSsrQueries = (args: UsePrefetchSsrQueriesArgs) => {
  const { eventHandle } = args;

  const isGuestSiteSsrEnabled = useIsGuestSiteSsrEnabled();
  const isStaysRedesignActive = useIsStaysRedesignActive();
  const skip = !isGuestSiteSsrEnabled;

  useFetchWebsiteHeaderSettings(eventHandle, skip);
  useFetchWebsitePageListData(eventHandle, { skip });

  // GuestPageContainerBySlug has no name-based refetchQueries risk, so skip-only gating is fine.
  useFetchCustomPageData(eventHandle, skip || !isStaysRedesignActive);
};
